import { $api } from 'modules/global';

export const getMyResult = (ticketId?: number | string) => async () => {
  const { data } = await $api.get('/myresult', { params: { ticket_id: ticketId } });

  return data;
};
